import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';
import { borderRadius } from '../../styles/mixins';

export const useShipmentSummariesStyles = createStyles(({ token }) => ({
  shipmentSummaries: {
    '&&': {
      '.SimpleCard': {
        ...borderRadius({ side: 'top' }),
      },
    },
    '.label.size-full': {
      fontSize: ThemeFont.FONT_SIZE_XS,
      fontWeight: 500,
    },
  },
  stickyElementInner: {
    '&&': {
      '.SimpleCard': {
        ...borderRadius({ side: 'top' }),
      },
    },
  },
  segmentedControlSegment: {
    [`@media (max-width: ${token.screenXSMax}px)`]: {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
  },
  copyToClipboardIcon: {
    marginTop: -2,
  },
  jobNumberRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    paddingLeft: ThemeSpaces.SPACE_NORM0_5,
    paddingRight: 0,
    borderBottomWidth: 0,
    minHeight: 20,

    '.label.size-sm': {
      width: 65,
    },
    '.IconButton': {
      padding: '0 2px',
    },
  },
  deliveryProof: {
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    fontWeight: 'normal',
    fontStyle: 'italic',
    color: ThemeColors.COLOR_BLUE2,
    textTransform: 'uppercase',
    marginTop: ThemeSpaces.SPACE_SM,
    marginBottom: ThemeSpaces.SPACE_NORM0_5 - ThemeSpaces.SPACE_SM,
  },
  slidingContentOverride: {
    '&&&': {
      '.SimpleCard, .SimpleCard-Body': {
        borderRadius: 0,
      },
      '.SimpleCard:last-child': {
        ...borderRadius({ side: 'bottom' }),
      },
      '.SimpleCard:last-child .SimpleCard-Body': {
        ...borderRadius({ side: 'bottom' }),
      },
    },
  },
}));
